import useGetBasePath from "~/hooks/useGetBasePath";

/**
 * Event And News Article Breadcrumbs Hook
 *
 * @param articleName
 * @param articleBase
 * @param articleDefaultLabel
 * @returns array
 */
const useArticleBreadcrumbs = (
    articleName,
    articleBase,
    articleDefaultLabel,
) => {
    const getBasePath = useGetBasePath();

    return [
        {
            pathname: getBasePath("pagesBase")?.url || "/",
            crumbLabel: getBasePath("pagesBase")?.label || "Home",
        },
        {
            pathname: getBasePath("companyBase")?.url || "",
            crumbLabel: getBasePath("companyBase")?.label || "Company",
        },
        {
            pathname: getBasePath("newsEventsBase")?.url || "",
            crumbLabel: getBasePath("newsEventsBase")?.label || "News & Events",
        },
        {
            pathname: getBasePath(articleBase)?.url || "",
            crumbLabel: getBasePath(articleBase)?.label || articleDefaultLabel,
        },
        { crumbLabel: articleName },
    ];
};

export default useArticleBreadcrumbs;
